import React, { memo } from "react";

import { EMPTY_ICON } from "Utils";

import { VisualStyled, ImageStyled, StateStyled } from "./styles";

interface GeneralInfoProps {
  link: string | undefined;
  name: string;
  // state: string;
  missionId: string | undefined;
  missionPlan: Mission | undefined;
  isLoading?: boolean;
  missionName?: string;
}

export const GeneralInfo = memo(
  ({
    link,
    name,
    missionId,
    missionPlan,
    isLoading,
    missionName,
  }: GeneralInfoProps) => {
    // Consider both isLoading and missionPlan availability
    const isStillLoading =
      isLoading || (missionId && !missionPlan && !missionName);

    const getMissionStatus = () => {
      if (isStillLoading) {
        return "Loading...";
      }

      // Use missionName from websocket if available
      if (missionName) {
        return missionName;
      }

      if (missionPlan?.name) {
        return missionPlan.name;
      }

      if (missionId) {
        return "Go to staging";
      }

      return "Ready for work";
    };

    return (
      <>
        <VisualStyled>
          <ImageStyled src={link ?? EMPTY_ICON} />
          <div>{name}</div>
        </VisualStyled>
        <StateStyled>
          <div>{getMissionStatus()}</div>
          {/* TODO: Add the feature when API is ready
          <ActionButton
            isCancel={true}
            onClick={() => {
              return;
            }}
          >
            End Mission
          </ActionButton>
        */}
        </StateStyled>
      </>
    );
  }
);
